let globalConfig = {
  imgFormat: 'image/*',
  imgFormatStrict: '.jpg,.jpeg,.png',
}

export default globalConfig;
